import React from 'react';
import VacationBadge from "../Vacation/VacationBadge";

function StoreOption(props) {
    return (
        <p className="flex gap-2 items-center truncate">
            {props.title} <VacationBadge {...props} />
        </p>
        // {address && (
        // 	<span className="block text-neutrals-400 text-12">{address}</span>
        // )}
    );
}

export default StoreOption;
